"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HouseTax = function HouseTax(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ viewBox: "0 0 64 64", className: "custom-icon" }, props),
    _react2.default.createElement("path", { d: "m55 12c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 4c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1z" }),
    _react2.default.createElement("path", { d: "m49 12c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3zm0-4c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z" }),
    _react2.default.createElement("path", { d: "m63 12c0-6.065-4.935-11-11-11s-11 4.935-11 11c0 .481.042.951.102 1.415l-6.098-7.114c-1.254-1.462-3.077-2.301-5.004-2.301s-3.75.839-5.004 2.302l-19.455 22.698h-4.541v6h2v22h-2v6h58v-6h-2v-22h2v-6h-4.541l-5.522-6.443c.974.283 1.999.443 3.063.443 6.065 0 11-4.935 11-11zm-58 23h2v22h-2zm15.303 16h19.395l9 6h-37.395zm20.697-1.535v-14.465h10v21.132zm-2-.465h-8v-14h8zm-10 0h-8v-14h8zm-10 .465-10 6.667v-21.132h10zm38 11.535h-54v-2h54zm-2-4h-2v-22h2zm2-24h-54v-2h54zm-43.558-4 16.11-18.794c.193-.227.702-.227.897 0l16.109 18.794zm35.749 0-17.223-20.095c-.959-1.119-2.978-1.119-3.935 0l-17.224 20.095h-2.636l18.34-21.396c.875-1.02 2.145-1.604 3.487-1.604s2.612.584 3.486 1.603l18.341 21.397zm2.809-26c4.963 0 9 4.037 9 9s-4.037 9-9 9-9-4.037-9-9 4.037-9 9-9z" }),
    _react2.default.createElement("path", { d: "m33 41h2v2h-2z" }),
    _react2.default.createElement("path", { d: "m25 41h2v2h-2z" })
  );
};

exports.default = HouseTax;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/housetax.js
// module id = 1788
// module chunks = 895